export default {"src":"/_next/static/media/pcce-logo.952d8bda.svg","height":41,"width":168,"blurWidth":0,"blurHeight":0};